import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full min-h-screen" style={{
    background: '#0D1B2A'
  }} data-id="element-294">
      <HeroSection data-id="element-295" />
      <ProblemSection data-id="element-296" />
      <SolutionSection data-id="element-297" />
      <WhatYouGetSection data-id="element-298" />
      <ForWhoSection data-id="element-299" />
      <HowItWorksSection data-id="element-300" />
      <ProofSection data-id="element-301" />
      <FAQSection data-id="element-302" />
      <OfferSection data-id="element-303" />
      <Footer data-id="element-304" />
    </main>;
}